import { render, staticRenderFns } from "./IncludeLogoCheckbox.vue?vue&type=template&id=4a694bc2&scoped=true"
import script from "./IncludeLogoCheckbox.vue?vue&type=script&lang=ts"
export * from "./IncludeLogoCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./IncludeLogoCheckbox.vue?vue&type=style&index=0&id=4a694bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a694bc2",
  null
  
)

export default component.exports